import loadable from '../../utilities/loadable'

export const WholesalerCard = loadable(() => import('./WholesalerCard'))
